import { cn } from '@rematter/ui-web';

export type TemplatePreviewProps = {
  previewUrl: string | undefined;
};

export const TemplatePreview = ({ previewUrl }: TemplatePreviewProps) => (
  <div className="@TemplatePreview h-full">
    {!previewUrl && (
      <div className="flex h-full items-center justify-center">
        <p className="text-neutral/50">Select a template to preview</p>
      </div>
    )}
    {previewUrl && (
      <div className={cn('@TemplatePreview h-full overflow-hidden')}>
        <iframe
          src={previewUrl}
          className="h-full w-full border-0"
          title="Template Preview"
        />
      </div>
    )}
  </div>
);
